import { render, staticRenderFns } from "./IconInfo2.vue?vue&type=template&id=1cc238a2&scoped=true&"
import script from "./IconInfo2.vue?vue&type=script&lang=js&"
export * from "./IconInfo2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc238a2",
  null
  
)

export default component.exports